import styled from "styled-components";

export const Container = styled.div`
  background-color: white;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 5rem 3.2rem 1.2rem;
  width: 49.5rem;

  .header {
    flex-shrink: 0;
    order: 1;
  }
  .content {
    order: 2;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    ::-webkit-scrollbar {
      display: none;
    }
  }
  .footer {
    flex-shrink: 0;
    order: 3;

    .block-hint {
      color: ${(props) => props.theme.colors.red};
      font-size: 1.4rem;
      text-align: center;
    }
  }

  .clickable-element {
    cursor: pointer;
  }
`;

export const Subtitle = styled.h2`
  ${({ theme }) => `
    color: ${theme.colors.primaryBlue};
  `}
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 0;
`;

export const Title = styled.h1`
  ${({ theme }) => `
    color: ${theme.colors.blackTextBody};
  `}
  font-size: 2.4rem;
  font-weight: 800;
  margin-bottom: 1.2rem;
  margin-top: 0.5rem;
`;

interface ISectionTitle {
  light?: any;
  small?: any;
}
export const SectionTitle = styled.h3<ISectionTitle>`
  ${({ theme, light, small }) => `
    color: ${
      light
        ? theme.colors.blackTextBody + theme.transparencies.p30
        : theme.colors.blackTextBody
    };
    font-size: ${small ? "1.2rem" : "1.4rem"};
  `}
  font-weight: 700;
`;

export const StatusContainer = styled.div`
  margin-bottom: 3.6rem;
  width: 14.5rem;
`;

export const InfoContainer = styled.div`
  margin-bottom: 1.2rem;
`;

export const MainButton = styled.button`
  ${({ theme, disabled }) => `
    background-color: ${theme.colors.accentGreen};
    color: ${theme.colors.white};
    cursor: ${disabled ? "default" : "pointer"};
  `}

  align-items: center;
  border-radius: 8px;
  border: none;
  display: flex;
  font-family: inherit;
  font-size: 1.7rem;
  font-weight: 700;
  height: 6.2rem;
  justify-content: center;
  width: 43.1rem;

  &:disabled,
  &[disabled] {
    background-color: ${({ theme }) =>
      theme.colors.accentGreen + theme.transparencies.p20};
  }

  img {
    height: 5rem;
    width: 5rem;
  }
`;

export const RowContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: 3rem;
`;

export const VehicleContainer = styled(RowContainer)`
  border-radius: 1rem;
  border: ${({ theme }) => `1px solid ${theme.colors.backgroundGray2}`};
  padding: 0.5rem 1.4rem;
`;

export const VolanteContainer = styled.div`
  align-items: center;
  border-radius: 1rem;
  box-shadow: 0px 5px 50px rgba(231, 231, 234, 0.62);
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 1.4rem;
`;

interface IText {
  small?: any;
}
export const Text = styled.p<IText>`
  ${({ theme, small }) => `
    color: ${theme.colors.blackTextBody};
    font-size: ${small ? "1.4rem" : "1.6rem"};
  `}
  font-weight: 500;
`;
